import script from "./CarCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CarCard.vue?vue&type=script&setup=true&lang=js"

import "./CarCard.vue?vue&type=style&index=0&id=48854ebc&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48854ebc"]])

export default __exports__